module.exports = __webpack_public_path__ + "img/XII_WORKSPOT_2026.1a2bd3e5.webp";